import CreateRemitAddress from "./CreateRemitAddress";
export default CreateRemitAddress;
